<template>
  <div class="container">
    <div>
      <div v-if="isReady" class="text-right flex items-center justify-end">
        <div class="text-sm">{{ pagination.current }}/{{ pagination.total }}</div>
        <button class="focus:outline-none border hover:bg-blue-lightest hover:border-blue-light ease mx-4 h-10 w-10 rounded-full flex items-center justify-center" @click="toPrev"><img :src="prev" alt="prev"></button>
        <button class="focus:outline-none border hover:bg-blue-lightest hover:border-blue-light ease mx-4 h-10 w-10 rounded-full flex items-center justify-center" @click="toNext"><img :src="next" alt="next"></button>
      </div>
    </div>
    <div class="flex flex-wrap">
      <Flicking ref="flicking" :options="{ align: 'center', circular: true }" @ready="onReady" @changed="onChanged" :plugins="plugins">
        <div v-for="(item, index) in showcasesList" class="slider-item" :key="index">
          <div class="p-16 my-8 mx-8 border border-grey-lightest shadow-md">
            <div class="flex justify-between mb-8">
              <h4 class="text-grey-darkest font-bold">{{ item.title[lang] }}</h4>
              <!-- <img :src="item.logo" style="height: 70px"> -->
            </div>
            <p class="text-sm text-grey-darker leading-md mb-16 h-12">
              {{ item.description[lang] }}
            </p>
            <div>
              <h5 class="mb-4">{{ item['product-name'][lang] }}</h5>
              <img :src="$filters.imageUrl(item['cover-image'].url)" :alt="item['cover-image'].name" class="block w-full rounded-sm">
            </div>
            <div class="mt-8">
              <template v-if="item.link[lang]">
                <a :href="item.link[lang]" target="_blank" class="btn btn-lg btn-block btn-solid btn-blue font-bold leading-lg py-4 rounded-sm text-center">{{ $t('cases.btn') }}</a>
              </template>
              <template v-else>
                <div class="btn btn-lg btn-block btn-solid btn-grey font-bold leading-lg py-4 rounded-sm text-center" :disabled="!item.link[lang]">{{ $t('cases.btn') }}</div>
              </template>
            </div>
          </div>
        </div>
      </Flicking>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import prev from '@/assets/prev.svg'
import next from '@/assets/next.svg'
import { Fade } from '@egjs/flicking-plugins'
import _ from 'lodash'
const plugins = [
  // new AutoPlay({ duration: 3000, direction: 'NEXT', stopOnHover: true }),
  new Fade()
]

export default {
  name: 'Cases',
  props: {
    showcases: {
      type: Array
    }
  },
  data () {
    return {
      plugins,
      isReady: false,
      pagination: {
        total: 0,
        current: 1
      },
      prev,
      next
    }
  },
  computed: {
    ...mapGetters(['lang']),
    showcasesList: function () {
      return _.chain(this.showcases).filter('active').orderBy(['sort'], ['asc']).value()
    }
  },
  methods: {
    onReady: function (e) {
      this.pagination.total = e.currentTarget.panelCount
      this.isReady = true
    },
    toPrev: function (e) {
      if (!this.$refs.flicking.animating) {
        this.$refs.flicking.prev()
      }
    },
    toNext: function (e) {
      if (!this.$refs.flicking.animating) {
        this.$refs.flicking.next()
      }
    },
    onChanged: function (e) {
      this.pagination.current = e.currentTarget.index + 1
    }
  }
}
</script>

<style lang="sass" scoped>
.slider-item
  @apply mb-16
  width: 80%
  @screen md
    width: 65%
  @screen lg
    width: 50%
</style>
